import React, { ReactNode } from 'react';

import classNames from 'classnames';

function PageContainer({
  children,
  isPageFullWidth = false,
  removeMobilePadding = false,
}: {
  children: ReactNode;
  isPageFullWidth?: boolean;
  removeMobilePadding?: boolean;
}) {
  return (
    <div
      className={classNames({
        'mx-auto xl:max-w-[1128px]': !isPageFullWidth,
        'px-4': !removeMobilePadding && !isPageFullWidth,
      })}
    >
      {children}
    </div>
  );
}

export default React.memo(PageContainer);
